var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFunnelCloseIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 9,
    height: 9,
    viewBox: "0 0 9 9",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.18984 4.2L8.19492 1.19492C8.46836 0.921484 8.46836 0.478516 8.19492 0.205078C7.92148 -0.0683594 7.47852 -0.0683594 7.20508 0.205078L4.2 3.21016L1.19492 0.205078C0.921484 -0.0683594 0.478516 -0.0683594 0.205078 0.205078C-0.0683594 0.478516 -0.0683594 0.921484 0.205078 1.19492L3.21016 4.2L0.205078 7.20508C-0.0683594 7.47852 -0.0683594 7.92148 0.205078 8.19492C0.341797 8.33164 0.520898 8.4 0.7 8.4C0.879102 8.4 1.0582 8.33164 1.19492 8.19492L4.2 5.18984L7.20508 8.19492C7.3418 8.33164 7.5209 8.4 7.7 8.4C7.8791 8.4 8.0582 8.33164 8.19492 8.19492C8.46836 7.92148 8.46836 7.47852 8.19492 7.20508L5.18984 4.2Z",
    fill: "#current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFunnelCloseIcon);
export default __webpack_public_path__ + "static/media/funnelCloseIcon.1c65144421572823ca4b40289f7a210d.svg";
export { ForwardRef as ReactComponent };